import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TemplateContinue } from '../../components/TemplateContinue';
// Temporary ignore to unblock while we find a fix for betterer and svg:
// Cannot find module '../../assets/device-based-phone-login.svg' or its
// corresponding type declarations;
// @ts-ignore
import deviceBasedImage from '../../assets/device-based-phone-login.svg';
import { selectLoadedPlatform } from '../../state/slices/slice-link-api';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import TermsOfService from '../../TermsOfService';
import useFireClientEvent from '../../hooks/useFireClientEvent';
var DeviceBasedImage = function () { return React.createElement("img", { src: deviceBasedImage, alt: "" }); };
var DeviceBasedPrimer = function (_a) {
    var onContinue = _a.onContinue;
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var getLocalizedString = useGetLocalizedString();
    var titleText = useMemo(function () {
        return getLocalizedString('DEVICE_BASED_PRIMER_TITLE', [loadedPlatform.name]);
    }, [getLocalizedString, loadedPlatform.name]);
    var subtitleText = useMemo(function () {
        return getLocalizedString('DEVICE_BASED_PRIMER_SUBTITLE', [loadedPlatform.name]);
    }, [getLocalizedString, loadedPlatform.name]);
    var buttonLabel = useMemo(function () { return getLocalizedString('CONTINUE'); }, [getLocalizedString]);
    var fireClientEvent = useFireClientEvent();
    useEffect(function () {
        fireClientEvent('input_required');
    }, [fireClientEvent]);
    return (React.createElement(TemplateContinue, { Image: DeviceBasedImage, title: titleText, subtitle: subtitleText, subtitleVariant: "caption", buttonLabel: buttonLabel, buttonEventId: "DeviceBasedPrimer-continue", onContinue: onContinue, extraControls: React.createElement(TermsOfService, null) }));
};
export default DeviceBasedPrimer;
